import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RankingList from "../RankingList";
import { Ranking } from "../../types/Game";
import Divider from "@mui/material/Divider";
import "./styles.scss";
import { CommonContent, Content, ContentKey } from "../../types/Types";
import ApiCommonContent from "./../../services/GenericContent";

type Props = {
  visible: boolean;
  cancel?: string;
  ok: string;
  onConfirm: () => void;
  onCancel?: () => void;
  data: Ranking[];
  content: CommonContent[];
};

export default function GameOverPopup(props: Props) {
  const handleClose = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <div>
      <Dialog
        open={props.visible}
        aria-labelledby="customized-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"  className="gameOverTitle">
          {ApiCommonContent.getKeyValue(
            props.content || [],
            ContentKey.END_OF_GAME
          )}
        </DialogTitle>
        <Divider />
        <DialogContent className="gameOverContent">
          <DialogContentText
            className="gameOverDescription"
            id="alert-dialog-description"
          >
            {ApiCommonContent.getKeyValue(
              props.content || [],
              ContentKey.BOARD_POSITIONS
            )}
          </DialogContentText>
          <Divider />
          <RankingList order="asc" orderBy="timeStamp" data={props.data}/>
        </DialogContent>
        <DialogActions className="gameOverActions">
          {props.cancel && props.onCancel && (
            <Button onClick={handleClose}>
              {ApiCommonContent.getKeyValue(
                props.content || [],
                ContentKey.EXIT_BOARD
              )}
            </Button>
          )}
          <Button
            onClick={() => {
              props.onConfirm();
            }}
            autoFocus
          >
            {ApiCommonContent.getKeyValue(
              props.content || [],
              ContentKey.GLOBAL_RANKING
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
